import { isString, parseStringRecord, StringRecord } from "./storageValidation";

const PROGRESS_KEY = "kanalearn.kanjiMemory.v1";
export type KanjiMemoryProgress = StringRecord<string>;

export function getProgress(): KanjiMemoryProgress {
    try {
        const raw = localStorage.getItem(PROGRESS_KEY);
        return parseStringRecord(raw, isString);
    } catch {
        return {};
    }
}

export function setProgress(progress: KanjiMemoryProgress): void {
    try {
        localStorage.setItem(PROGRESS_KEY, JSON.stringify(progress));
    } catch {
        // Best-effort: if storage is unavailable, progress just won't persist.
    }
}
